import { z } from 'zod'

export const STRATALYST_REPORT_ARTIFACT_CONTRACT_VERSION = '1.0.0' as const
export const stratalystReportArtifactResponseSchema = z.unknown()
export type StratalystReportArtifactResponse = z.infer<typeof stratalystReportArtifactResponseSchema>
